/**
 * @export
 * @class AppEndPoint
 */
export abstract class AppEndPoint {
    public static readonly DOCUMENTS_UPLOAD_PATH = 'assets/image/user/upload/';
    public static readonly USERS = 'auth/users/';
    public static readonly DOCUMENTS = 'document/document/';
    public static readonly FOLLOWUP = 'followup/followup/';
}